<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <CCard>
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center"
    >
      Data Anggota
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.push('/keanggotaan/data-anggota/unverified')"
        >Kembali</Button
      >
    </div>
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item border-0">
        <router-link
          :to="
            '/keanggotaan/data-anggota/data-diri/' + this.$route.params.id_user
          "
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          style="background-color: #214073 !important"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
          >Data Anggota</router-link
        >
      </li>
      <li class="nav-item border-0">
        <router-link
          :to="
            '/keanggotaan/data-anggota/data-sertifikasi/' +
            this.$route.params.id_user
          "
          style="background-color: #214073 !important"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
          >Data Sertifikasi</router-link
        >
      </li>

      <li class="nav-item border-0">
        <router-link
          :to="
            '/keanggotaan/data-anggota/data-rpl/' + this.$route.params.id_user
          "
          style="background-color: #214073 !important"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
          >Data RPL</router-link
        >
      </li>
      <li class="nav-item border-0">
        <router-link
          :to="
            '/keanggotaan/data-anggota/data-pelatihan/' +
            this.$route.params.id_user
          "
          style="background-color: #214073 !important"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
          >Data Pelatihan</router-link
        >
      </li>
      <li class="nav-item border-0">
        <router-link
          :to="'/keanggotaan/data-anggota/sanksi/' + this.$route.params.id_user"
          style="background-color: #486ba7"
          class="nav-link p-3 px-4 font-weight-bold text-white border-0"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
          >Sanksi</router-link
        >
      </li>
    </ul>
    <CCardBody>
        <CCol>
          <CDataTable
            style="widht: 100% !important"
            :items="items"
            :fields="fields"
            hover
            sorter
          >
            <template #no="{ index }">
              <td class="py-2">{{indexed == 0 ? index + 1 : index + indexed + 1}}</td>
            </template>
            <template #nomor_sanksi="{ item }">
              <td class="py-2 text-left font-weight-bold">
                {{ item.nomor_sanksi ? item.nomor_sanksi : "-" }}
              </td>
            </template>
            <template #nama_lengkap="{ item }">
              <td class="py-2 text-left">
                {{ item.nama_lengkap ? item.nama_lengkap : "-" }}
              </td>
            </template>
            <template #nama_kategori="{ item }">
              <td class="py-2 text-left">
                {{ item.nama_kategori ? item.nama_kategori : "-" }}
              </td>
            </template>
            <template #sanksi="{ item }">
              <td class="py-2 text-left">
                {{ item.sanksi ? item.sanksi : "-" }}
              </td>
            </template>
            <template #no_anggota="{ item }">
              <td class="py-2 text-left font-weight-bold">
                {{ item.no_anggota ? item.no_anggota : "-" }}
              </td>
            </template>
            <template #sanksi_berakhir="{ item }">
              <td class="py-2 text-left">
                {{ item.sanksi_berakhir ? item.sanksi_berakhir : "-" }}
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float: right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
    </CCardBody>
  </CCard>
</template>
<script>
import SanksiService from '@/services/keanggotaan/sanksi/sanksi.service.js';
import { Pagination } from "@/mixins/Pagination";

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false,
  },
  {
    key: "nomor_sanksi",
    label: "Nomor Sanksi",
    sorter: true,
    filter: false,
  },
  {
    key: "no_anggota",
    label: "Nomor Anggota",
    sorter: true,
    filter: false,
  },
  {
    key: "nama_lengkap",
    label: "Nama Lengkap",
    sorter: true,
    filter: false,
  },
  {
    key: "nama_kategori",
    label: "Kategori Anggota",
    sorter: true,
    filter: false,
  },
  {
    key: "sanksi",
    label: "Sanksi",
    sorter: true,
    filter: false,
  },
  {
    key: "keterangan",
    label: "Keterangan",
    sorter: true,
    filter: false,
  },
  {
    key: "tanggal_berakhir",
    label: "Tanggal Sanksi Berakhir",
    sorter: false,
    filter: false,
  },
];

export default {
  mixins: [Pagination],
  data() {
    return {
      formData: {
        statusSanksiSertifikasi: false,
        statusSanksiRpl: false,
        statusSanksiPelatihan: false,
        alasan: '',        
        Alasan: '',        
        id_user: '',
      },
      fields,
    }
  },
  mounted() {
    this.getData("0", this.pageSize, "default");
  },
 methods: {

   pageChange() {
      this.getData(
        this.currentPage,
        this.pageSize,
        this.search,
      );
    },

   getData(currentPage, pageSize, filter, idUser) {
      if (filter == "") {
        filter = "default";
      }
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      SanksiService.getSanksiAnggota(currentPage, pageSize, filter, this.$route.params.id_user)
        .then((response) => {
          loader.hide();
          // comment console console.log(response.data);
          // comment console console.log(response.data.data.content);
          this.items = response.data.data.content;
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
        })
        .catch((error) => {
          loader.hide();
          // comment console console.log(error);
        });
    },
 } 
}
</script>
